<div class="error-section">
  <div class="ui container">
    <div class="header">
      ERROR: {{error.title}}
    </div>
    <p>{{error.message}}
      <!-- <span *ngIf="error.url">at {{error.url}}</span> -->
    </p>
  </div>
</div>